export default __webpack_public_path__ + "static/B0124-4ae718251cad8dcf6bfc53987cbcfced.png";